import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var LocationsOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M9.99992 1.6748C6.78659 1.6748 4.1731 4.28992 4.1731 7.50326C4.1731 11.2391 9.14535 17.3076 9.35701 17.5635L9.99992 18.3431L10.6428 17.5635C10.8545 17.3068 15.8267 11.2391 15.8267 7.50326C15.8267 4.28909 13.2133 1.6748 9.99992 1.6748ZM9.99992 3.34147C12.2941 3.34147 14.1601 5.20909 14.1601 7.50326C14.1601 9.75742 11.5649 13.6343 9.99992 15.6885C8.43492 13.636 5.83976 9.76076 5.83976 7.50326C5.83976 5.20909 7.70575 3.34147 9.99992 3.34147ZM9.99992 5.41667C8.84909 5.41667 7.91659 6.34917 7.91659 7.5C7.91659 8.65083 8.84909 9.58333 9.99992 9.58333C11.1508 9.58333 12.0833 8.65083 12.0833 7.5C12.0833 6.34917 11.1508 5.41667 9.99992 5.41667Z",
    fill: fill
  }));
};
export { LocationsOutline as default };
//# sourceMappingURL=LocationsOutline.js.map
